import { ReactElement } from 'react';
import { TotalItem } from 'devextreme-react/data-grid';
import { conditionalTwoDigitSummaryCurrency } from './constants/constants';

import React from 'react';

interface IDrawAutomaticBorrowerTotalItemsProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
}

export const DrawAutomaticBorrowerTotalItems = ({
    drawId,
    drawNumber,
    drawFinalized,
}: IDrawAutomaticBorrowerTotalItemsProps): ReactElement[] => {
    if (drawFinalized) {
        return [
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
        ];
    } else {
        return [
            <TotalItem
                name={`drawItems-inspection-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-inspection-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
        ];
    }
};
